// src/components/common/TaglineBar.js
import React from 'react';
import './TaglineBar.css';

function TaglineBar({ tagline, taglines, intervalMs = 5000 }) {
  const defaultTagline = "INFO COLAB : Votre Vision. Notre Code. Votre Succès.";

  const messages = Array.isArray(taglines) && taglines.length
    ? taglines.filter(Boolean)
    : [tagline || defaultTagline].filter(Boolean);

  const buildTagsGroup = (items) => {
    const out = [];
    items.forEach((text, i) => {
      out.push(
        <span key={`t-${i}-${text}`} className="tagline-pill">{text}</span>
      );
      if (i < items.length - 1) {
        out.push(
          <span key={`sep-${i}`} className="tagline-marquee-sep">•</span>
        );
      }
    });
    return out;
  };

  if (!messages.length) {
    return null; // Ne rien rendre si pas de tagline
  }

  return (
    <div className="tagline-bar">
      {/* Tu peux aussi utiliser la classe .container ici si tu veux que le texte
          soit limité en largeur, mais pour une tagline, pleine largeur est souvent bien.
      <div className="container"> */}
        <div className="tagline-marquee" aria-label="Taglines">
          <div className="tagline-marquee-track">
            <span className="tagline-marquee-group" aria-hidden="true">
              {buildTagsGroup(messages)}
            </span>
            <span className="tagline-marquee-group" aria-hidden="true">
              {buildTagsGroup(messages)}
            </span>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
}

export default TaglineBar;